// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__21nbx","Main":"Slider_Main__1EXJD","Text":"Slider_Text__2kwpH"};